import { render, staticRenderFns } from "./smartico-vip-level.vue?vue&type=template&id=5ad21c9c&scoped=true&"
import script from "./smartico-vip-level.ts?vue&type=script&lang=ts&"
export * from "./smartico-vip-level.ts?vue&type=script&lang=ts&"
import style0 from "./smartico-vip-level.scss?vue&type=style&index=0&id=5ad21c9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad21c9c",
  null
  
)

component.options.__file = "smartico-vip-level.vue"
export default component.exports